import { z } from 'zod';
import { auditEventSchema } from './audit';
import { balanceSchema, movementSchema } from './billing';
import { legalAcceptanceSchema, legalDocumentSchema } from './legal';
import { cursorPageQuerySchema } from './pagination';

// Esquemas de administración de accesos (RF-01.20 a RF-01.27).

export const invitationCreateSchema = z.object({
  maxUses: z.number().int().positive().nullable(),
  expiresAt: z.iso.datetime().nullable(),
  note: z.string().max(300),
});

export const invitationCreatedSchema = z.object({
  id: z.uuid(),
  /** Se muestra una sola vez: después solo queda el prefijo. */
  code: z.string(),
});

export const invitationSchema = z.object({
  id: z.uuid(),
  codePrefix: z.string(),
  maxUses: z.number().int().nullable(),
  uses: z.number().int(),
  expiresAt: z.iso.datetime().nullable(),
  revokedAt: z.iso.datetime().nullable(),
  note: z.string(),
  createdAt: z.iso.datetime(),
});

export const membershipSchema = z.object({
  plan: z.enum(['unassigned', 'monthly', 'annual', 'lifetime']),
  renewalOn: z.iso.date().nullable(),
  origin: z.string(),
  notes: z.string(),
  reviewedAt: z.iso.datetime().nullable(),
  version: z.number().int(),
});

export const membershipUpdateSchema = z.object({
  plan: z.string().max(20),
  renewalOn: z.string().max(10).nullable(),
  origin: z.string().max(120),
  notes: z.string().max(2000),
  version: z.number().int().min(0),
});

export const userAccessSchema = z.object({
  roles: z.array(z.string()),
  permissions: z.array(z.string()),
  blocked: z.boolean(),
  blockReason: z.string().nullable(),
  overrides: z.array(
    z.object({ permission: z.string(), effect: z.enum(['grant', 'deny']), reason: z.string() }),
  ),
  membership: membershipSchema,
});

export const rolesUpdateSchema = z.object({ roles: z.array(z.string().max(40)).max(10) });
export const overrideSetSchema = z.object({
  effect: z.enum(['grant', 'deny']),
  reason: z.string().max(500),
});
export const blockSchema = z.object({ reason: z.string().max(500) });

// Usuarios en administración (RF-08.02, RF-08.03, RF-08.17). El email va enmascarado: el
// completo solo con la acción explícita y auditada de revelarlo.

export const adminUserSchema = z
  .object({
    id: z.uuid(),
    emailMasked: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    skoolName: z.string(),
    status: z.enum(['active', 'disabled']),
    mfaEnabled: z.boolean(),
    createdAt: z.iso.datetime(),
    lastLoginAt: z.iso.datetime().nullable(),
  })
  .meta({ id: 'AdminUser' });

export const adminUsersQuerySchema = cursorPageQuerySchema.extend({
  q: z.string().max(100).optional(),
});

export const adminUserDetailSchema = z.object({
  user: adminUserSchema.extend({ legacyId: z.number().int().nullable() }),
  access: userAccessSchema,
  balance: balanceSchema,
  movements: z.array(movementSchema),
  acceptances: z.array(legalAcceptanceSchema),
  pendingLegal: z.array(legalDocumentSchema),
  auditEvents: z.array(auditEventSchema),
});

export const revealedEmailSchema = z.object({ email: z.string() });
